module.exports = __webpack_public_path__ + "static/media/elk@2x.92b0d5d7.jpg";